// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as CountryCodeRouteImport } from './routes/$countryCode'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as StoreRouteImport } from './routes/store'
import { Route as CountryCodeIndexRouteImport } from './routes/$countryCode/index'
import { Route as CountryCodeSplatRouteImport } from './routes/$countryCode/$'
import { Route as CountryCodeAboutRouteImport } from './routes/$countryCode/about'
import { Route as CountryCodeAccessibilityRouteImport } from './routes/$countryCode/accessibility'
import { Route as CountryCodeBrunchRouteImport } from './routes/$countryCode/brunch'
import { Route as CountryCodeCartRouteImport } from './routes/$countryCode/cart'
import { Route as CountryCodeCateringRouteImport } from './routes/$countryCode/catering'
import { Route as CountryCodeCheckoutRouteImport } from './routes/$countryCode/checkout'
import { Route as CountryCodeCoffeeRouteImport } from './routes/$countryCode/coffee'
import { Route as CountryCodeColabRouteImport } from './routes/$countryCode/colab'
import { Route as CountryCodeContactRouteImport } from './routes/$countryCode/contact'
import { Route as CountryCodeFaqRouteImport } from './routes/$countryCode/faq'
import { Route as CountryCodeMatchaRouteImport } from './routes/$countryCode/matcha'
import { Route as CountryCodeMenuRouteImport } from './routes/$countryCode/menu'
import { Route as CountryCodePrivacyPolicyRouteImport } from './routes/$countryCode/privacy-policy'
import { Route as CountryCodeSaltBreadRouteImport } from './routes/$countryCode/salt-bread'
import { Route as CountryCodeStoreRouteImport } from './routes/$countryCode/store'
import { Route as CountryCodeTermsAndConditionsRouteImport } from './routes/$countryCode/terms-and-conditions'
import { Route as CountryCodeVisitRouteImport } from './routes/$countryCode/visit'
import { Route as CountryCodeAccountIndexRouteImport } from './routes/$countryCode/account/index'
import { Route as CountryCodeAccountAddressesRouteImport } from './routes/$countryCode/account/addresses'
import { Route as CountryCodeAccountForgotPasswordRouteImport } from './routes/$countryCode/account/forgot-password'
import { Route as CountryCodeAccountLoginRouteImport } from './routes/$countryCode/account/login'
import { Route as CountryCodeAccountProfileRouteImport } from './routes/$countryCode/account/profile'
import { Route as CountryCodeAccountRegisterRouteImport } from './routes/$countryCode/account/register'
import { Route as CountryCodeAccountResetPasswordRouteImport } from './routes/$countryCode/account/reset-password'
import { Route as CountryCodeAccountVerifyEmailRouteImport } from './routes/$countryCode/account/verify-email'
import { Route as CountryCodeCategoriesHandleRouteImport } from './routes/$countryCode/categories/$handle'
import { Route as CountryCodeOrderConfirmedRouteImport } from './routes/$countryCode/order/confirmed'
import { Route as CountryCodeProductsHandleRouteImport } from './routes/$countryCode/products/$handle'
import { Route as CountryCodeAccountOrdersIndexRouteImport } from './routes/$countryCode/account/orders/index'
import { Route as CountryCodeAccountOrdersOrderIdRouteImport } from './routes/$countryCode/account/orders/$orderId'
import { Route as CountryCodeOrderOrderIdConfirmedRouteImport } from './routes/$countryCode/order/$orderId/confirmed'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const CountryCodeRoute = CountryCodeRouteImport.update({
            id: '/$countryCode',path: '/$countryCode',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const StoreRoute = StoreRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => rootRouteImport
          })
const CountryCodeIndexRoute = CountryCodeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeSplatRoute = CountryCodeSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAboutRoute = CountryCodeAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccessibilityRoute = CountryCodeAccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeBrunchRoute = CountryCodeBrunchRouteImport.update({
            id: '/brunch',path: '/brunch',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeCartRoute = CountryCodeCartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeCateringRoute = CountryCodeCateringRouteImport.update({
            id: '/catering',path: '/catering',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeCheckoutRoute = CountryCodeCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeCoffeeRoute = CountryCodeCoffeeRouteImport.update({
            id: '/coffee',path: '/coffee',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeColabRoute = CountryCodeColabRouteImport.update({
            id: '/colab',path: '/colab',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeContactRoute = CountryCodeContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeFaqRoute = CountryCodeFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeMatchaRoute = CountryCodeMatchaRouteImport.update({
            id: '/matcha',path: '/matcha',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeMenuRoute = CountryCodeMenuRouteImport.update({
            id: '/menu',path: '/menu',getParentRoute: () => CountryCodeRoute
          })
const CountryCodePrivacyPolicyRoute = CountryCodePrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeSaltBreadRoute = CountryCodeSaltBreadRouteImport.update({
            id: '/salt-bread',path: '/salt-bread',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeStoreRoute = CountryCodeStoreRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeTermsAndConditionsRoute = CountryCodeTermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeVisitRoute = CountryCodeVisitRouteImport.update({
            id: '/visit',path: '/visit',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountIndexRoute = CountryCodeAccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountAddressesRoute = CountryCodeAccountAddressesRouteImport.update({
            id: '/account/addresses',path: '/account/addresses',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountForgotPasswordRoute = CountryCodeAccountForgotPasswordRouteImport.update({
            id: '/account/forgot-password',path: '/account/forgot-password',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountLoginRoute = CountryCodeAccountLoginRouteImport.update({
            id: '/account/login',path: '/account/login',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountProfileRoute = CountryCodeAccountProfileRouteImport.update({
            id: '/account/profile',path: '/account/profile',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountRegisterRoute = CountryCodeAccountRegisterRouteImport.update({
            id: '/account/register',path: '/account/register',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountResetPasswordRoute = CountryCodeAccountResetPasswordRouteImport.update({
            id: '/account/reset-password',path: '/account/reset-password',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountVerifyEmailRoute = CountryCodeAccountVerifyEmailRouteImport.update({
            id: '/account/verify-email',path: '/account/verify-email',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeCategoriesHandleRoute = CountryCodeCategoriesHandleRouteImport.update({
            id: '/categories/$handle',path: '/categories/$handle',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeOrderConfirmedRoute = CountryCodeOrderConfirmedRouteImport.update({
            id: '/order/confirmed',path: '/order/confirmed',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeProductsHandleRoute = CountryCodeProductsHandleRouteImport.update({
            id: '/products/$handle',path: '/products/$handle',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountOrdersIndexRoute = CountryCodeAccountOrdersIndexRouteImport.update({
            id: '/account/orders/',path: '/account/orders/',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeAccountOrdersOrderIdRoute = CountryCodeAccountOrdersOrderIdRouteImport.update({
            id: '/account/orders/$orderId',path: '/account/orders/$orderId',getParentRoute: () => CountryCodeRoute
          })
const CountryCodeOrderOrderIdConfirmedRoute = CountryCodeOrderOrderIdConfirmedRouteImport.update({
            id: '/order/$orderId/confirmed',path: '/order/$orderId/confirmed',getParentRoute: () => CountryCodeRoute
          })





const CountryCodeRouteChildren = {
  CountryCodeSplatRoute: CountryCodeSplatRoute,CountryCodeAboutRoute: CountryCodeAboutRoute,CountryCodeAccessibilityRoute: CountryCodeAccessibilityRoute,CountryCodeBrunchRoute: CountryCodeBrunchRoute,CountryCodeCartRoute: CountryCodeCartRoute,CountryCodeCateringRoute: CountryCodeCateringRoute,CountryCodeCheckoutRoute: CountryCodeCheckoutRoute,CountryCodeCoffeeRoute: CountryCodeCoffeeRoute,CountryCodeColabRoute: CountryCodeColabRoute,CountryCodeContactRoute: CountryCodeContactRoute,CountryCodeFaqRoute: CountryCodeFaqRoute,CountryCodeMatchaRoute: CountryCodeMatchaRoute,CountryCodeMenuRoute: CountryCodeMenuRoute,CountryCodePrivacyPolicyRoute: CountryCodePrivacyPolicyRoute,CountryCodeSaltBreadRoute: CountryCodeSaltBreadRoute,CountryCodeStoreRoute: CountryCodeStoreRoute,CountryCodeTermsAndConditionsRoute: CountryCodeTermsAndConditionsRoute,CountryCodeVisitRoute: CountryCodeVisitRoute,CountryCodeIndexRoute: CountryCodeIndexRoute,CountryCodeAccountAddressesRoute: CountryCodeAccountAddressesRoute,CountryCodeAccountForgotPasswordRoute: CountryCodeAccountForgotPasswordRoute,CountryCodeAccountLoginRoute: CountryCodeAccountLoginRoute,CountryCodeAccountProfileRoute: CountryCodeAccountProfileRoute,CountryCodeAccountRegisterRoute: CountryCodeAccountRegisterRoute,CountryCodeAccountResetPasswordRoute: CountryCodeAccountResetPasswordRoute,CountryCodeAccountVerifyEmailRoute: CountryCodeAccountVerifyEmailRoute,CountryCodeCategoriesHandleRoute: CountryCodeCategoriesHandleRoute,CountryCodeOrderConfirmedRoute: CountryCodeOrderConfirmedRoute,CountryCodeProductsHandleRoute: CountryCodeProductsHandleRoute,CountryCodeAccountIndexRoute: CountryCodeAccountIndexRoute,CountryCodeAccountOrdersOrderIdRoute: CountryCodeAccountOrdersOrderIdRoute,CountryCodeOrderOrderIdConfirmedRoute: CountryCodeOrderOrderIdConfirmedRoute,CountryCodeAccountOrdersIndexRoute: CountryCodeAccountOrdersIndexRoute
}

const CountryCodeRouteWithChildren = CountryCodeRoute._addFileChildren(CountryCodeRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,CountryCodeRoute: CountryCodeRouteWithChildren,AccessibilityRoute: AccessibilityRoute,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,StoreRoute: StoreRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)